// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remote_device_page{
    background: #F2F2F2;
    padding: 20px;
    width: calc(97.7vw - 240px - 60px);
    /* height: calc(100vh - 150px); */

    overflow-y: scroll;
}
input[type=checkbox] {
    accent-color: #3295F1;
  }
.model_row{
 display: flex;
 flex-direction: row;
 align-items: center;
 justify-content: space-between;   
}
.model_selector{
 display: flex;
 align-items: center;
 gap: 30px;
 color: #303239;
 font-weight: 400;
font-size: 12px;
}
.filter_selector{
    display: flex;
 align-items: center;
 gap: 10px;
 color: #303239;
 font-weight: 400;
font-size: 12px;
}

.vehicle_stat{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background: #FFFFFF;
    border: 1px solid #DDE6F1;
    margin-top: 20px;
    height: 224px;
}
.seperator{
    height: 200px;
    border: 1px solid #DDE6F1;
    transform: translateX(-100px);
}
.vehicle_stat_row{
    transform: translateX(-100px);
 box-sizing: border-box;
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 justify-content: space-between;
 padding: 10px 20px;
 gap: 28px; 
}
.vehicle_stat_meta{
    color: #A3A7B5;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
}

.vehicle_stat_data{
    color: #303239;
}


.schedule_button{
    border-radius: 8px;
    width: 144px;
    height: 42px;
    font-weight: 700;
    font-family: 'DM Sans';
    color: #000000;
    text-transform: none;
    border-color: #000000;
}
.listview_main{
    background-color: white;
    height: 72vh;
    width: 80vw;
    margin-left: 3%;
    margin-top: 1%;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
}
.listview_tools{
    display: flex;
    justify-content: space-between;

}
.listview_tools_left{
    display: flex;
    align-items: center;
    
}
.listview_tools_right{
    display: flex;
    align-items: center;
    gap: 14px;
    margin-right: 4%;
    margin-top: 1%;

}
/* .listview_tools_right.div{
    margin-left: 20px;
} */

.remote_device_buttons{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    gap: 15px;
}

.latest_version{
   font-weight: 600;
    font-size: 12px;
    width: auto;
    height: auto;
    min-height: 20px;
    background: rgba(169, 200, 106, 0.33);
    padding: 2px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #62AD41;
    text-transform: uppercase;

}
.needs_upgrade{
   font-weight: 600;
    font-size: 12px;
    width: 115.42px;
    height: 20px;
    background: #ECECEC;
    padding: 2px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #555759;
    text-transform: uppercase;
}
.incompatible{
    font-weight: 600;
     font-size: 12px;
     width: 150.42px;
     height: 20px;
     background: #ECECEC;
     padding: 2px;
     padding-left: 15px;
     padding-right: 15px;
     display: flex;

     align-items: center;
     justify-content: center;
     color: #555759;
     text-transform: uppercase;
 }
.scan_status {
    width: 60px
}
.in_progress{
    background: #E9F4FB;
    /* border-radius: 14px; */
   font-weight: 600;
    font-size: 12px;
    width: auto;
    height: 20px;
    padding: 2px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    /* justify-content: flex-start; */
    justify-content: center;
    color: #555759;
    text-transform: uppercase;

}
.device_status_row{
    display: flex;
    align-items: center;
    justify-content: left;
    padding-left: 12px;
}
.online_dot{
    width: 6px;
    height: 6px;
    margin-right: 6px;
    background: #62AD41;
    border-radius: 100%; 
}
.offline_dot{
    width: 6px;
    height: 6px;
    margin-right: 6px;
    background: #555759;
    border-radius: 100%; 
}
.latest_version_dot{
    width: 6px;
    height: 6px;
    margin-right: 6px;
    background: #A9C86A;
    border-radius: 100%;
    
}
.needs_upgrade_dot{
    width: 5px;
    height: 5px;
    background: #ABABAB;
    border-radius: 100%;
}
.in_progress_dot{
    margin-right: 7px;
    margin-top: 6px;
    width: 10px;
    height: 10px;
    animation: rotation 2s infinite linear;
}
@keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

.Listdot{
    width: 6px;
    height: 6px;
    background: black;
    border-radius: 100%;
    margin-right: 7px;
    margin-top: 9px;
}
.upgrade_status_row{
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content:center;
    padding-top: 10px;
}

.last_updated{
    margin-top: 5px;
    font-weight: 400;
    font-size: 11px;
    text-align: center;
}

.arrow_box{
    padding: 5px;
}

.dashboard_title_remote{
    margin-bottom: 13px;
    padding: 0;
}
.empty_table_text{
    /* width: 100%; */
    margin-top: 20px;
    text-align: center;
    align-items: center;
    color: #ABABAB;
    font-size: 30px;
    /* height: 40px; */
    
}


.remote_device_table{
    margin: 25px;
    margin-top: 0px;
    text-align: center;
    width: 100%;
    border-collapse: collapse;
    
}
.remote_device_table_header{
    height: 40px;
    color: #555759;
    font-size: 15px;
    background: #3174A4;
    border: 1px solid #5A83A0;
    font-weight: 600;
    font-size: 12px;
    color: #FFFFFF;
    

}
.remote_device_table_header_row{
    font-weight: 500;
    font-size: 14px;
    border: 1px solid #5A83A0;
    text-align: left;
    padding-left: 12px;
}
.remote_device_table_row{
    height: 44px;
    font-weight: 500;
    font-size: 14px;
    background-color: rgb(255, 255, 255);
    border-bottom: 1px solid #E9ECEF;
    font-weight: 400;
    font-size: 14px;
    color: #404145;
}
.row_text_style{
    text-align: left;
    padding-left: 12px;
    
}
.remote_device_table_row_active{
    background: #F0F8FF;
    /* background: #F5F8ED; */
    /* box-shadow: 0px 4px 4px rgba(169, 200, 106, 0.21); */
    
}

.row_text_style{
    text-align: left;
    padding-left: 12px;  
}
.row_text_style_icon{
    /* display: flex;
    justify-content: center; */
    text-align: left;
    padding-left: 24px;
    cursor: pointer;  
}

/* tr:nth-child(even) {
    background-color: rgba(246, 246, 246, 0.8);
} */
.list_panel_style{
    display: flex;
    min-height: 50vh;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    margin-top: 20px;
}

.list_panel_style_scan{
    display: flex;
    min-height: 60vh;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    margin-top: 50px;
} 

.alertMessage {
    font-weight: 400;
    font-size: medium;
    font-family: 'DM Sans', sans-serif;
}

.Initializing {
    font-weight: bold;
    display:inline-block;
    font-family: 'DM Sans', sans-serif;
    font-size: 30px;
    clip-path: inset(0 3ch 0 0);
    animation: l 1s steps(4) infinite;
}
.grid {
    display: grid;
    place-items: center;
}
.img {
    max-width: 100%;
}
.loginImage img {
    max-width: 200vw;
  }

.emptyContent{
    position: relative;
    top: 50% ;
    margin-left: 63%;
    transform: translate(-50% , -50% );
    color: grey;
    font-weight: bold;
    font-size: 16px;
}
.emptyContent2{
    position: relative;
    top: 50% ;
    margin-left: 55%;
    transform: translate(-50% , -50% );
    color: grey;
    font-weight: bold;
    font-size: 16px;
}
@keyframes blink {50% { color: transparent }}
.loader__dot { animation: 1s blink infinite }
.loader__dot:nth-child(2) { animation-delay: 250ms }
.loader__dot:nth-child(3) { animation-delay: 500ms }


.remote_device_table_header input:checked ~ .checkmark {
    background-color: #404145;
    opacity: 0.15;
  }


  .initialSotwareUpgradePage{
    background: #F2F2F2;
    padding: 20px;
    width: calc(97.7vw - 240px - 60px);
    height: calc(100vh - 100px);
    overflow-y: scroll;
  }
  
  .boxName{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    padding-top: 10px;
    /* margin-top: 10px; */
    color: #A3A7B5;
  }

  .horizontalLine{
    margin-left: 5px;
    margin-top: 20px;
    width: 100vw;
    height: 0px;
    left: 79px;
    top: 87px;
    border: 1px solid #A3A7B5;
  }

.containerBox {
  position: relative;
  margin: 9px;
  width: 258px;
  height: 148px;
  cursor: pointer;
}
.containerBox::before {
    content: '';
    position: absolute;
    left: 0; top: 0;
    width: 258px; height: 148px;
    background: linear-gradient(71.59deg, rgba(0, 0, 0, 0.87) 17.19%, rgba(0, 0, 0, 0.61) 51.56%, rgba(0, 0, 0, 0.25) 83.85%);
}
.containerBox::after {
    content: '';
    position:absolute;
    left: 0; top: 0;
    width: 258px; height: 148px;
    background: linear-gradient(359.51deg, rgba(0, 0, 0, 0.49) 17.46%, rgba(0, 0, 0, 0) 30.56%);
  }
.image{
  display:block;
  width: 100%;
  height: auto;
}
.bottom-left {
  position: absolute;
  z-index: 1;
  bottom: 8px;
  left: 16px;
  color: white;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 19px;
  margin-left: 12px;
  align-items: center;
}
  
.cards{
    display: flex;
    margin-top: 1%;
}

.update_alert{
    position: fixed;
    top: 20px;
    left: 40%;
}

.rectangle {
    width: 15px; /* Adjust width as needed */
    height: 15px; /* Adjust height as needed */
    background-color: #84B249; /* Adjust color as needed */
    margin-left: 10px;
  }

  .rectangle1 {
    width: 15px; /* Adjust width as needed */
    height: 15px; /* Adjust height as needed */
    background-color: #FFBF5E; /* Adjust color as needed */
    margin-left: 10px;
  }
  
  .rectangle2 {
    width: 15px; /* Adjust width as needed */
    height: 15px; /* Adjust height as needed */
    background-color: #F75D5D; /* Adjust color as needed */
    margin-left: 10px;
  }
  
  .rectangle3 {
    width: 15px; /* Adjust width as needed */
    height: 15px; /* Adjust height as needed */
    background-color: #818181; /* Adjust color as needed */
    margin-left: 10px;
  }
  
  
  .label {
    margin-top: 10px;
    font-size: 11px;
    color: black;
    margin-left: 10px;
    margin-top: -1px;
    /* font-weight: bold; */
  }`, "",{"version":3,"sources":["webpack://./src/Components/SoftwareUpgrade/softwareUpgrade.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,iCAAiC;;IAEjC,kBAAkB;AACtB;AACA;IACI,qBAAqB;EACvB;AACF;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;AAC/B;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,gBAAgB;AACjB,eAAe;AACf;AACA;IACI,aAAa;CAChB,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,gBAAgB;AACjB,eAAe;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,6BAA6B;CAChC,sBAAsB;CACtB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,8BAA8B;CAC9B,kBAAkB;CAClB,SAAS;AACV;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,8BAA8B;;AAElC;AACA;IACI,aAAa;IACb,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;;AAElB;AACA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;GACG,gBAAgB;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;;AAE7B;AACA;GACG,gBAAgB;IACf,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,gBAAgB;KACf,eAAe;KACf,eAAe;KACf,YAAY;KACZ,mBAAmB;KACnB,YAAY;KACZ,kBAAkB;KAClB,mBAAmB;KACnB,aAAa;;KAEb,mBAAmB;KACnB,uBAAuB;KACvB,cAAc;KACd,yBAAyB;CAC7B;AACD;IACI;AACJ;AACA;IACI,mBAAmB;IACnB,yBAAyB;GAC1B,gBAAgB;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,uBAAuB;IACvB,cAAc;IACd,yBAAyB;;AAE7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sCAAsC;AAC1C;AACA;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;AAEF;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;;AAEtB;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,yBAAyB;;AAE7B;AACA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;;;AAGlB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,uDAAuD;;AAE3D;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI;8BAC0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;GAEG;AACH;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kCAAkC;IAClC,eAAe;IACf,2BAA2B;IAC3B,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;EAClB;;AAEF;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA,kBAAkB,MAAM,mBAAmB,CAAC;AAC5C,eAAe,6BAA6B;AAC5C,4BAA4B,uBAAuB;AACnD,4BAA4B,uBAAuB;;;AAGnD;IACI,yBAAyB;IACzB,aAAa;EACf;;;EAGA;IACE,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,yBAAyB;EAC3B;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO,EAAE,MAAM;IACf,YAAY,EAAE,aAAa;IAC3B,yHAAyH;AAC7H;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,OAAO,EAAE,MAAM;IACf,YAAY,EAAE,aAAa;IAC3B,2FAA2F;EAC7F;AACF;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB,EAAE,2BAA2B;IACtD,iBAAiB;EACnB;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB,EAAE,2BAA2B;IACtD,iBAAiB;EACnB;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB,EAAE,2BAA2B;IACtD,iBAAiB;EACnB;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB,EAAE,2BAA2B;IACtD,iBAAiB;EACnB;;;EAGA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;EACzB","sourcesContent":[".remote_device_page{\r\n    background: #F2F2F2;\r\n    padding: 20px;\r\n    width: calc(97.7vw - 240px - 60px);\r\n    /* height: calc(100vh - 150px); */\r\n\r\n    overflow-y: scroll;\r\n}\r\ninput[type=checkbox] {\r\n    accent-color: #3295F1;\r\n  }\r\n.model_row{\r\n display: flex;\r\n flex-direction: row;\r\n align-items: center;\r\n justify-content: space-between;   \r\n}\r\n.model_selector{\r\n display: flex;\r\n align-items: center;\r\n gap: 30px;\r\n color: #303239;\r\n font-weight: 400;\r\nfont-size: 12px;\r\n}\r\n.filter_selector{\r\n    display: flex;\r\n align-items: center;\r\n gap: 10px;\r\n color: #303239;\r\n font-weight: 400;\r\nfont-size: 12px;\r\n}\r\n\r\n.vehicle_stat{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n    background: #FFFFFF;\r\n    border: 1px solid #DDE6F1;\r\n    margin-top: 20px;\r\n    height: 224px;\r\n}\r\n.seperator{\r\n    height: 200px;\r\n    border: 1px solid #DDE6F1;\r\n    transform: translateX(-100px);\r\n}\r\n.vehicle_stat_row{\r\n    transform: translateX(-100px);\r\n box-sizing: border-box;\r\n display: flex;\r\n flex-direction: column;\r\n align-items: flex-start;\r\n justify-content: space-between;\r\n padding: 10px 20px;\r\n gap: 28px; \r\n}\r\n.vehicle_stat_meta{\r\n    color: #A3A7B5;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n}\r\n\r\n.vehicle_stat_data{\r\n    color: #303239;\r\n}\r\n\r\n\r\n.schedule_button{\r\n    border-radius: 8px;\r\n    width: 144px;\r\n    height: 42px;\r\n    font-weight: 700;\r\n    font-family: 'DM Sans';\r\n    color: #000000;\r\n    text-transform: none;\r\n    border-color: #000000;\r\n}\r\n.listview_main{\r\n    background-color: white;\r\n    height: 72vh;\r\n    width: 80vw;\r\n    margin-left: 3%;\r\n    margin-top: 1%;\r\n    border-radius: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.listview_tools{\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n}\r\n.listview_tools_left{\r\n    display: flex;\r\n    align-items: center;\r\n    \r\n}\r\n.listview_tools_right{\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n    margin-right: 4%;\r\n    margin-top: 1%;\r\n\r\n}\r\n/* .listview_tools_right.div{\r\n    margin-left: 20px;\r\n} */\r\n\r\n.remote_device_buttons{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n    gap: 15px;\r\n}\r\n\r\n.latest_version{\r\n   font-weight: 600;\r\n    font-size: 12px;\r\n    width: auto;\r\n    height: auto;\r\n    min-height: 20px;\r\n    background: rgba(169, 200, 106, 0.33);\r\n    padding: 2px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    color: #62AD41;\r\n    text-transform: uppercase;\r\n\r\n}\r\n.needs_upgrade{\r\n   font-weight: 600;\r\n    font-size: 12px;\r\n    width: 115.42px;\r\n    height: 20px;\r\n    background: #ECECEC;\r\n    padding: 2px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    color: #555759;\r\n    text-transform: uppercase;\r\n}\r\n.incompatible{\r\n    font-weight: 600;\r\n     font-size: 12px;\r\n     width: 150.42px;\r\n     height: 20px;\r\n     background: #ECECEC;\r\n     padding: 2px;\r\n     padding-left: 15px;\r\n     padding-right: 15px;\r\n     display: flex;\r\n\r\n     align-items: center;\r\n     justify-content: center;\r\n     color: #555759;\r\n     text-transform: uppercase;\r\n }\r\n.scan_status {\r\n    width: 60px\r\n}\r\n.in_progress{\r\n    background: #E9F4FB;\r\n    /* border-radius: 14px; */\r\n   font-weight: 600;\r\n    font-size: 12px;\r\n    width: auto;\r\n    height: 20px;\r\n    padding: 2px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    /* justify-content: flex-start; */\r\n    justify-content: center;\r\n    color: #555759;\r\n    text-transform: uppercase;\r\n\r\n}\r\n.device_status_row{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: left;\r\n    padding-left: 12px;\r\n}\r\n.online_dot{\r\n    width: 6px;\r\n    height: 6px;\r\n    margin-right: 6px;\r\n    background: #62AD41;\r\n    border-radius: 100%; \r\n}\r\n.offline_dot{\r\n    width: 6px;\r\n    height: 6px;\r\n    margin-right: 6px;\r\n    background: #555759;\r\n    border-radius: 100%; \r\n}\r\n.latest_version_dot{\r\n    width: 6px;\r\n    height: 6px;\r\n    margin-right: 6px;\r\n    background: #A9C86A;\r\n    border-radius: 100%;\r\n    \r\n}\r\n.needs_upgrade_dot{\r\n    width: 5px;\r\n    height: 5px;\r\n    background: #ABABAB;\r\n    border-radius: 100%;\r\n}\r\n.in_progress_dot{\r\n    margin-right: 7px;\r\n    margin-top: 6px;\r\n    width: 10px;\r\n    height: 10px;\r\n    animation: rotation 2s infinite linear;\r\n}\r\n@keyframes rotation {\r\n    from {\r\n      transform: rotate(0deg);\r\n    }\r\n    to {\r\n      transform: rotate(359deg);\r\n    }\r\n  }\r\n\r\n.Listdot{\r\n    width: 6px;\r\n    height: 6px;\r\n    background: black;\r\n    border-radius: 100%;\r\n    margin-right: 7px;\r\n    margin-top: 9px;\r\n}\r\n.upgrade_status_row{\r\n    margin-left: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content:center;\r\n    padding-top: 10px;\r\n}\r\n\r\n.last_updated{\r\n    margin-top: 5px;\r\n    font-weight: 400;\r\n    font-size: 11px;\r\n    text-align: center;\r\n}\r\n\r\n.arrow_box{\r\n    padding: 5px;\r\n}\r\n\r\n.dashboard_title_remote{\r\n    margin-bottom: 13px;\r\n    padding: 0;\r\n}\r\n.empty_table_text{\r\n    /* width: 100%; */\r\n    margin-top: 20px;\r\n    text-align: center;\r\n    align-items: center;\r\n    color: #ABABAB;\r\n    font-size: 30px;\r\n    /* height: 40px; */\r\n    \r\n}\r\n\r\n\r\n.remote_device_table{\r\n    margin: 25px;\r\n    margin-top: 0px;\r\n    text-align: center;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    \r\n}\r\n.remote_device_table_header{\r\n    height: 40px;\r\n    color: #555759;\r\n    font-size: 15px;\r\n    background: #3174A4;\r\n    border: 1px solid #5A83A0;\r\n    font-weight: 600;\r\n    font-size: 12px;\r\n    color: #FFFFFF;\r\n    \r\n\r\n}\r\n.remote_device_table_header_row{\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    border: 1px solid #5A83A0;\r\n    text-align: left;\r\n    padding-left: 12px;\r\n}\r\n.remote_device_table_row{\r\n    height: 44px;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    background-color: rgb(255, 255, 255);\r\n    border-bottom: 1px solid #E9ECEF;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    color: #404145;\r\n}\r\n.row_text_style{\r\n    text-align: left;\r\n    padding-left: 12px;\r\n    \r\n}\r\n.remote_device_table_row_active{\r\n    background: #F0F8FF;\r\n    /* background: #F5F8ED; */\r\n    /* box-shadow: 0px 4px 4px rgba(169, 200, 106, 0.21); */\r\n    \r\n}\r\n\r\n.row_text_style{\r\n    text-align: left;\r\n    padding-left: 12px;  \r\n}\r\n.row_text_style_icon{\r\n    /* display: flex;\r\n    justify-content: center; */\r\n    text-align: left;\r\n    padding-left: 24px;\r\n    cursor: pointer;  \r\n}\r\n\r\n/* tr:nth-child(even) {\r\n    background-color: rgba(246, 246, 246, 0.8);\r\n} */\r\n.list_panel_style{\r\n    display: flex;\r\n    min-height: 50vh;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: white;\r\n    margin-top: 20px;\r\n}\r\n\r\n.list_panel_style_scan{\r\n    display: flex;\r\n    min-height: 60vh;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: white;\r\n    margin-top: 50px;\r\n} \r\n\r\n.alertMessage {\r\n    font-weight: 400;\r\n    font-size: medium;\r\n    font-family: 'DM Sans', sans-serif;\r\n}\r\n\r\n.Initializing {\r\n    font-weight: bold;\r\n    display:inline-block;\r\n    font-family: 'DM Sans', sans-serif;\r\n    font-size: 30px;\r\n    clip-path: inset(0 3ch 0 0);\r\n    animation: l 1s steps(4) infinite;\r\n}\r\n.grid {\r\n    display: grid;\r\n    place-items: center;\r\n}\r\n.img {\r\n    max-width: 100%;\r\n}\r\n.loginImage img {\r\n    max-width: 200vw;\r\n  }\r\n\r\n.emptyContent{\r\n    position: relative;\r\n    top: 50% ;\r\n    margin-left: 63%;\r\n    transform: translate(-50% , -50% );\r\n    color: grey;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n}\r\n.emptyContent2{\r\n    position: relative;\r\n    top: 50% ;\r\n    margin-left: 55%;\r\n    transform: translate(-50% , -50% );\r\n    color: grey;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n}\r\n@keyframes blink {50% { color: transparent }}\r\n.loader__dot { animation: 1s blink infinite }\r\n.loader__dot:nth-child(2) { animation-delay: 250ms }\r\n.loader__dot:nth-child(3) { animation-delay: 500ms }\r\n\r\n\r\n.remote_device_table_header input:checked ~ .checkmark {\r\n    background-color: #404145;\r\n    opacity: 0.15;\r\n  }\r\n\r\n\r\n  .initialSotwareUpgradePage{\r\n    background: #F2F2F2;\r\n    padding: 20px;\r\n    width: calc(97.7vw - 240px - 60px);\r\n    height: calc(100vh - 100px);\r\n    overflow-y: scroll;\r\n  }\r\n  \r\n  .boxName{\r\n    font-family: 'Poppins';\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    padding-top: 10px;\r\n    /* margin-top: 10px; */\r\n    color: #A3A7B5;\r\n  }\r\n\r\n  .horizontalLine{\r\n    margin-left: 5px;\r\n    margin-top: 20px;\r\n    width: 100vw;\r\n    height: 0px;\r\n    left: 79px;\r\n    top: 87px;\r\n    border: 1px solid #A3A7B5;\r\n  }\r\n\r\n.containerBox {\r\n  position: relative;\r\n  margin: 9px;\r\n  width: 258px;\r\n  height: 148px;\r\n  cursor: pointer;\r\n}\r\n.containerBox::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0; top: 0;\r\n    width: 258px; height: 148px;\r\n    background: linear-gradient(71.59deg, rgba(0, 0, 0, 0.87) 17.19%, rgba(0, 0, 0, 0.61) 51.56%, rgba(0, 0, 0, 0.25) 83.85%);\r\n}\r\n.containerBox::after {\r\n    content: '';\r\n    position:absolute;\r\n    left: 0; top: 0;\r\n    width: 258px; height: 148px;\r\n    background: linear-gradient(359.51deg, rgba(0, 0, 0, 0.49) 17.46%, rgba(0, 0, 0, 0) 30.56%);\r\n  }\r\n.image{\r\n  display:block;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n.bottom-left {\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 8px;\r\n  left: 16px;\r\n  color: white;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  margin-bottom: 19px;\r\n  margin-left: 12px;\r\n  align-items: center;\r\n}\r\n  \r\n.cards{\r\n    display: flex;\r\n    margin-top: 1%;\r\n}\r\n\r\n.update_alert{\r\n    position: fixed;\r\n    top: 20px;\r\n    left: 40%;\r\n}\r\n\r\n.rectangle {\r\n    width: 15px; /* Adjust width as needed */\r\n    height: 15px; /* Adjust height as needed */\r\n    background-color: #84B249; /* Adjust color as needed */\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .rectangle1 {\r\n    width: 15px; /* Adjust width as needed */\r\n    height: 15px; /* Adjust height as needed */\r\n    background-color: #FFBF5E; /* Adjust color as needed */\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .rectangle2 {\r\n    width: 15px; /* Adjust width as needed */\r\n    height: 15px; /* Adjust height as needed */\r\n    background-color: #F75D5D; /* Adjust color as needed */\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .rectangle3 {\r\n    width: 15px; /* Adjust width as needed */\r\n    height: 15px; /* Adjust height as needed */\r\n    background-color: #818181; /* Adjust color as needed */\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  \r\n  .label {\r\n    margin-top: 10px;\r\n    font-size: 11px;\r\n    color: black;\r\n    margin-left: 10px;\r\n    margin-top: -1px;\r\n    /* font-weight: bold; */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
